import { ROUTE_PATHS } from 'core/constants/routePath'
import { RootState } from 'core/store'
import React, { ReactNode, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

const ErrorHandler: React.FC<{ children: ReactNode }> = ({ children }) => {
  const error = useSelector((state: RootState) => state.error.code)
  const navigate = useNavigate()

  useEffect(() => {
    if (error === 403) {
      navigate(ROUTE_PATHS.ERROR_403, { replace: true })
    } else if (error === 404) {
      navigate(ROUTE_PATHS.ERROR_404, { replace: true })
    } else if (error === 500) {
      navigate(ROUTE_PATHS.ERROR, { replace: true })
    }
  }, [error, navigate])

  return <>{children}</>
}

export default ErrorHandler
